module.exports = __webpack_public_path__ + "media/gai08.c761c44f.mp3";